export default function getQuery(){
  if(typeof window === undefined) return null;
  const location = window.location;

  const queryStrings = location && location.search.replace('?', '');

  let queryParams;
  let query = {};

  if (queryStrings){
    const params = queryStrings.split('&');
    for (let i = 0; i < params.length; i += 1){
      const pair = params[i].split('=');
      queryParams[pair[0]] = decodeURIComponent(pair[1]);
    }
    query = {}
    return query;
  }

  return null;
}